import React, { Component } from "react"
import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"

import {
    createProfileToggleFilter,
    enumSingleGenericFilter,
    datePickerGenericFilter,
    // sorting functions
    enumValueSort,
    enumOrderSort,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    LegislatorSearchifyWithoutCampaignFinanceFLV,
    BillFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import { DateListSelect } from "app/static/frontend/selects/containers/EnumSelect"

import { BillSelect, LegislatorSelectWithoutCampaignFinance } from "app/static/frontend/selects/containers/PieSelect"

export class AmendmentBillFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "amendmentBillFilter",
            filterKey: "about_bill",
            dataTypeLabel: "Bills",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AmendmentTypeFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "amendmentTypeFilter",
        filterKey: "current_type",
        trueText: "Senate",
        falseText: "House",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const AmendmentSponsorFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
AmendmentSponsorFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "amendmentSponsorFilter",
    filterKey: "sponsored_by_or",
    dataTypeLabel: "Legislators",
    displayLabel: "Sponsors",
    searchifyFLV: LegislatorSearchifyWithoutCampaignFinanceFLV,
    searchifyPermanentFilter: { most_recent_person_type: DjangIO.app.person.types.PersonType.member.value },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
}

export const AmendmentCosponsorFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
AmendmentCosponsorFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "amendmentCosponsorFilter",
    filterKey: "cosponsored_by_or",
    dataTypeLabel: "Legislators",
    displayLabel: "Cosponsors",
    searchifyFLV: LegislatorSearchifyWithoutCampaignFinanceFLV,
    searchifyPermanentFilter: { most_recent_person_type: DjangIO.app.person.types.PersonType.member.value },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
}

export const AmendmentSponsorOrCosponsorFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
AmendmentSponsorOrCosponsorFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "amendmentSponsorOrCosponsor",
    filterKey: "sponsored_or_cosponsored_by_or",
    dataTypeLabel: "Legislators",
    displayLabel: "Sponsor Or Cosponsors",
    searchifyFLV: LegislatorSearchifyWithoutCampaignFinanceFLV,
    searchifyPermanentFilter: { most_recent_person_type: DjangIO.app.person.types.PersonType.member.value },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
}

export class AmendmentStatusFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "amendmentStatusFilter",
        filterKey: "status__in",
        enumItems: DjangIO.app.bill.models.AmendmentStatus.region_supported_items(),
        sortBy: enumValueSort,
        displayKey: "full_name",
        displayLabel: "Current Status",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AmendmentStatusDateFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "amendmentStatusDateFilter",
        filterKey: "status_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
        sortBy: enumOrderSort,
        displayLabel: "Last Updated",
        selectComponent: DateListSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AmendmentOfferedDateStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "amendmentOfferedDateStart",
        filterKey: "offered_date__gt",
        displayLabel: "Offered After",
        helpText: "Amendments offered after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AmendmentOfferedDateEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "amendmentOfferedDateEnd",
        filterKey: "offered_date__lt",
        displayLabel: "Offered Before",
        helpText: "Amendments offered before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const AmendmentCommitteProfileFilter = createProfileToggleFilter({
    uniqueFilterId: "amendmentCommitteProfileFilter",
    trueText: "Committee + All Sub Committees",
    falseText: "Current Committee Only",
    filterKeyMapping: {
        true: "from_committees",
        false: "from_committee",
    },
})
